const CASHIER_TOASTS = {
    CASHIER_NOT_FETCHED: "Failed to fetch cashiers",
    CASHIERS_DELETED: "Selected cashiers deleted succesfully!",
    CASHIERS_NOT_DELETED: "Failed to delete selecetd cashiers!",
    CASHIER_ADDED: "Cashier successfully added!",
    CASHIER_NOT_ADDED: "Failed to add cashier",
    CASHIER_DELETED: "Cashier deleted succesfully!",
    CASHIER_NOT_DELETED: "Failed to delete cashier",
    INVALID_CASHIER: "Invalid cashier ID",
    CASHIER_UPDATED: "Cashier updated successfully",
    CASHIER_NOT_UPDATED: "Failed to update cashier"

}
 export default CASHIER_TOASTS